/* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable no-shadow */
import React, { useState, useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import { useForm } from 'react-hook-form';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import moment from 'moment';
import ReactTooltip from 'react-tooltip';
import { useSelector, useDispatch } from 'react-redux';
import Questionmark from '../assets/img/question-mark.svg';
import useApi from '../hooks/useApi';
import { checkoutDecision, addPayFrequency, addVwoDecision } from '../redux/actions';
import ErrorHandling from '../components/ErrorHandling/index';
import SubmitButton from '../components/SubmitButton';
import convertToCurrency from '../helpers/convertToCurrency';
import useListenSize from '../hooks/useListenSize';
import { segmentEvent } from '../helpers/sendEvent';

function PayCheckDetails() {
  const {
    handleSubmit,
    register,
    formState: { errors, isSubmitted },
  } = useForm();

  const paymentFrequency = register('payment_frequency', {
    required: 'This field is required',
  });
  const [frequency, setFrequency] = useState('');
  const [lastPayDayDate, setLastPayDayDate] = useState(null);
  const [startDate, setStartDate] = useState(moment().toDate());
  // const [endDate, setEndDate] = useState(moment().toDate());

  const { request, loading, error, response } = useApi();
  const history = useHistory();
  useListenSize();

  const dispatch = useDispatch();
  const store = useSelector(state => ({
    availableLimit: state.loanInfo?.availableLimit,
    uid: state.loanInfo?.uid,
    firstName: state.personal?.firstName,
    route: state.technical?.route,
    synchrony: state.technical?.synchrony,
    DEdgeToken: state.technical?.DEdgeToken,
  }));

  useEffect(() => {
    segmentEvent('page', 'Income Info');
  }, []);

  useEffect(() => {
    if (store.route) {
      history.push(store.route);
    }
  }, [store.route]);

  useEffect(() => {
    if (frequency === 'weekly') {
      setStartDate(moment().subtract(1, 'week').subtract(3, 'days').toDate());
    }
    if (frequency === 'bi-weekly') {
      setStartDate(moment().subtract(2, 'weeks').subtract(3, 'days').toDate());
    }
    if (frequency === 'monthly') {
      setStartDate(moment().subtract(1, 'month').subtract(3, 'days').toDate());
    }
    if (frequency === 'semi-monthly') {
      setStartDate(moment().subtract(16, 'days').subtract(3, 'days').toDate());
    }
  }, [frequency]);

  const financeData = {
    preapprove: store.availableLimit,
  };

  // eslint-disable-next-line consistent-return
  const getNextPayDate = () => {
    if (frequency === 'weekly') {
      return moment(lastPayDayDate).add(1, 'week');
    }
    if (frequency === 'bi-weekly') {
      return moment(lastPayDayDate).add(2, 'week');
    }
    if (frequency === 'monthly') {
      return moment(lastPayDayDate).add(1, 'month');
    }
    if (frequency === 'semi-monthly') {
      return moment(lastPayDayDate).add(16, 'days');
    }
  };

  const onSubmit = async values => {
    const uid = store.uid;
    if (lastPayDayDate) {
      if (store.synchrony?.isSynchrony) {
        history.push('/congratulation');
      }
      const nextPayDate = getNextPayDate(lastPayDayDate).format('YYYY-MM-DD');
      const patchApplicationRequest = await request.patchApplicationRequest(uid, {
        ...values,
        last_pay_date: moment(lastPayDayDate).format('YYYY-MM-DD'),
        next_pay_date: nextPayDate,
      });

      if (patchApplicationRequest) {
        segmentEvent('track', 'Income Info Submitted', {
          pay_frequency: frequency,
          last_pay_date: moment(lastPayDayDate).format('YYYY-MM-DD'),
          next_pay_date: nextPayDate,
        });

        const payload = { uid: store.uid, dedge_token: store.DEdgeToken };
        // eslint-disable-next-line no-console
        console.log('checkout endpoint payload: ', payload);
        const checkoutRequest = await request.checkoutRequest(payload);

        if (checkoutRequest.vwo) {
          dispatch(
            addVwoDecision({
              feature: 'checkoutPage',
              variation: checkoutRequest.vwo[0]?.wayfair_payment_page,
            }),
          );
        }

        dispatch(checkoutDecision({ response: checkoutRequest }));
      }
    }
  };

  return (
    <div className="k-content-wrapper">
      <ErrorHandling response={response} error={error} />
      <section className="k-info">
        <h1>Congratulations {store.firstName}!</h1>
        <p style={{ fontWeight: '500' }}>
          You are pre-approved for Katapult’s lease-to-own program to spend up to{' '}
          {convertToCurrency(financeData.preapprove)?.trim()}. <br />
          Please complete the details below to get started!
        </p>
      </section>
      <section className="k-info" style={{ marginTop: '40px' }}>
        <h2>Your Paycheck Details</h2>
      </section>
      <section className="k-form k-form-indent">
        <form onSubmit={handleSubmit(onSubmit)}>
          <div className="k-field animate__animated animate__fadeInDown">
            <img
              style={{ position: 'absolute', top: '4px', left: '207px' }}
              data-event="click"
              className="k-tooltip-icon"
              data-tip
              data-for="frequencyInfoTooltip"
              src={Questionmark}
              alt="How often do you get paid?"
            />
            {/* eslint-disable-next-line jsx-a11y/label-has-associated-control */}
            <label htmlFor="payment_frequency">How often do you get paid? </label>
            <select
              name="payment_frequency"
              id="payment_frequency"
              onChange={event => {
                paymentFrequency.onChange(event);
                setFrequency(event.target.value);
                dispatch(addPayFrequency(event.target.value));
              }}
              onBlur={paymentFrequency.onBlur}
              ref={paymentFrequency.ref}
            >
              <option value="">Select a pay frequency </option>
              <option value="weekly">Weekly</option>
              <option value="bi-weekly">Bi-Weekly</option>
              <option value="monthly">Monthly</option>
              <option value="semi-monthly">Semi-Monthly</option>
            </select>
            <div className="k-form-validation-message">
              {errors.payment_frequency && errors.payment_frequency.message}
            </div>
          </div>
          <div className="animate__animated animate__fadeInDown k-calendars-wrapper">
            <div className="k-field">
              {/* eslint-disable-next-line jsx-a11y/label-has-associated-control */}
              <label htmlFor="last_pay_date_new">When was your last pay day?</label>
              <DatePicker
                id="last_pay_date_new"
                name="last_pay_date_new"
                onChange={date => {
                  setLastPayDayDate(date);
                }}
                selected={lastPayDayDate}
                minDate={startDate}
                maxDate={moment().toDate()}
              />
            </div>
            {!lastPayDayDate && isSubmitted && <div className="k-form-validation-message">This field is required</div>}
          </div>
          {store.synchrony?.isSynchrony && (
            <div className="animate__animated animate__fadeInDown">
              <div>
                <div className="synchrony-deposit-title">Do you receive direct deposit?</div>
                <div className="synchrony-deposit-container">
                  {/* eslint-disable-next-line jsx-a11y/label-has-associated-control */}
                  <label htmlFor="direct_deposit" className="synchrony-deposit-label">
                    Yes
                    <input
                      type="radio"
                      className="synchrony-deposit-input"
                      name="direct_deposit"
                      value="yes"
                      {...register('agreeWarranty')}
                    />
                  </label>
                  <label htmlFor="direct_deposit" className="synchrony-deposit-label">
                    No
                    <input
                      type="radio"
                      className="synchrony-deposit-input"
                      name="direct_deposit"
                      value="no"
                      {...register('agreeWarranty')}
                    />
                  </label>
                </div>
              </div>
            </div>
          )}
          <SubmitButton loading={loading} />
        </form>
      </section>
      <ReactTooltip
        globalEventOff="click"
        clickable
        className="k-tooltip-theme"
        data-html
        id="frequencyInfoTooltip"
        place="bottom"
        effect="solid"
      >
        <table border="0" className="k-tooltip-content">
          <thead>
            <tr>
              <th colSpan="2" className="k-tooltip-content-center">
                The payment schedule for your lease <br /> will be based on your pay frequency.
              </th>
            </tr>
            <tr>
              <th>Pay Frequency</th>
              <th>Example</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>Weekly - 7 days between paychecks.</td>
              <td>Oct 1st, Oct 8th</td>
            </tr>
            <tr>
              <td>Every other week - 14 days between paychecks. </td>
              <td>Oct 2nd, Oct 16th</td>
            </tr>
            <tr>
              <td>
                Twice a month - Bi monthly paychecks, <br /> scheduled for the same day each month.
              </td>
              <td>Oct 1st, Oct 15th</td>
            </tr>
            <tr>
              <td>
                Monthly- Paycheck reoccuring on <br /> the same day each month.{' '}
              </td>
              <td>Oct 1st, Nov 1st</td>
            </tr>
          </tbody>
        </table>
      </ReactTooltip>
    </div>
  );
}

export default PayCheckDetails;
